<template>
  <div class="main-container">
    <div class="item settlement-status" v-if="infoForm.id">
      结算状态：
      <div v-if="infoForm.settlementStatus == 0" class="tag-settled">待结算</div>
      <div v-else class="tag-be">已结算</div>
    </div>

    <div @click="foldBtn(1)" class="foldblock">
      <Icon :type="fold ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
      <span class="title">基本信息</span>
    </div>
    <Form :model="infoForm" ref="infoFormRef" class="page-form form-container" :label-width="110" v-show="fold">
      <FormItem label="报表类型" prop="reportType" :rules="$units.formRule.required('请选择报表类型')">
        <Select v-model="infoForm.reportType" placeholder="请选择" @on-change="changeActivityType" :disabled="nextData.settled">
          <Option value="4-2">出单活动-梯度</Option>
          <Option value="2-1">增员活动-无门槛</Option>
          <Option value="2-2">增员活动-梯度</Option>
          <Option value="4-1">出单活动-无门槛</Option>
          <Option value="5-2">签约活动</Option>
        </Select>
      </FormItem>

      <FormItem label="结算报表名称" prop="reportName" :rules="$units.formRule.required('请输入结算报表名称')">
        <Input type="text" v-model="infoForm.reportName" placeholder="请输入" />
      </FormItem>

      <FormItem label="产品类型" prop="productType" :rules="$units.formRule.required('请选择产品类型')" v-if="infoForm.reportType == '4-1'">
        <Select v-model="infoForm.productType" placeholder="请选择" clearable @on-change="changeProductType" :disabled="nextData.settled">
          <Option value="1">个险</Option>
          <Option value="2">团财险</Option>
        </Select>
      </FormItem>

      <FormItem
        v-if="infoForm.reportType == '4-1'"
        label="关联活动"
        prop="activityIds"
        :rules="$units.formRule.arrRequired('请选择关联活动', 'change')"
        key="4-1"
      >
        <Select
          v-model="infoForm.activityIds"
          placeholder="请选择"
          filterable
          clearable
          @on-change="changeActivitySelect"
          :disabled="nextData.settled"
          multiple
          :max-tag-count="1"
        >
          <Option :value="item.id" v-for="(item, index) in activityList" :key="index"
            >{{ item.name }}({{ item.startTime && item.startTime.substr(0, 10) }}到{{ item.endTime && item.endTime.substr(0, 10) }})</Option
          >
        </Select>
      </FormItem>
      <FormItem v-else label="关联活动" prop="activityId" :rules="$units.formRule.required('请选择关联活动', 'change')" key="4-2">
        <Select v-model="infoForm.activityId" placeholder="请选择" filterable clearable @on-change="changeActivitySelect" :disabled="nextData.settled">
          <Option :value="item.id" v-for="(item, index) in activityList" :key="index"
            >{{ item.name }}({{ item.startTime && item.startTime.substr(0, 10) }}到{{ item.endTime && item.endTime.substr(0, 10) }})</Option
          >
        </Select>
      </FormItem>

      <FormItem label="结算机构" prop="orgIds" :rules="$units.formRule.arrRequired('请选择结算机构', (trigger = 'change'))">
        <selectTree
          v-model="infoForm.orgIds"
          type="4"
          :maxTagCount="1"
          :multiple="true"
          ref="selectTreeRef"
          @change="changeTreeOrg"
          :disabled="nextData.settled"
        >
        </selectTree>
      </FormItem>

      <FormItem label="结算日期" prop="settlementDate" :rules="$units.formRule.required('请选择结算日期')">
        <DatePicker
          type="date"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          @on-change="infoForm.settlementDate = $event"
          :value="infoForm.settlementDate"
          :disabled="nextData.settled"
        ></DatePicker>
      </FormItem>

      <FormItem label="备注" prop="remark">
        <Input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="infoForm.remark" placeholder="请输入" />
      </FormItem>
    </Form>
    <Divider />

    <div @click="foldBtn(2)" class="foldblock">
      <Icon :type="foldData ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
      <span class="title">待结算数据</span>
    </div>

    <div v-show="foldData">
      <div class="search-tools">
        <div class="search-box btn3" v-if="infoForm.type == 2 && infoForm.activityType == 2">
          <div class="input-item">
            <span class="label">推荐人</span>
            <Select placeholder="请选择" v-model="search.recommendId" clearable filterable>
              <Option v-for="(item, i) in userList" :key="i" :value="item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
              </Option>
            </Select>
          </div>
          <Button type="primary" @click="searchAjax()">搜索</Button>
        </div>
        <!-- 签约活动不显示查询 -->
        <div class="search-box btn3" v-else-if="!(infoForm.type == 5 && infoForm.activityType == 2)">
          <div class="input-item">
            <span class="label">保单号</span>
            <Input v-model="search.policyNo" clearable placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">业务员</span>
            <Select placeholder="请选择" v-model="search.owerId" clearable filterable>
              <Option v-for="(item, i) in userList" :key="i" :value="item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
              </Option>
            </Select>
          </div>
          <Button type="primary" @click="searchAjax()">搜索</Button>
        </div>
      </div>

      <div class="statistics-container" v-if="infoForm.type == 2 && infoForm.activityType == 2">
        <p>汇总数据</p>
        <div class="statistics-item">
          <span class="dot"></span>
          <span>推荐人数量：</span>
          <span class="num">{{ statisticsData.recommendNum || 0 }}人</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>被推荐人数量：</span>
          <span class="num">{{ statisticsData.beRecommendedNum || 0 }}人</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>总奖励：</span>
          <span class="num">{{ statisticsData.rewardPrice || 0 }}元</span>
        </div>
      </div>
      <div class="statistics-container" v-else-if="infoForm.type == 5 && infoForm.activityType == 2">
        <p>汇总数据</p>
        <div class="statistics-item">
          <span class="dot"></span>
          <span>签约人数：</span>
          <span class="num">{{ statisticsData.recommendNum || 0 }}人</span>
        </div>
        <div class="statistics-item">
          <span class="dot"></span>
          <span>总奖励：</span>
          <span class="num">{{ statisticsData.rewardPrice || 0 }}元</span>
        </div>
      </div>
      <div class="statistics-container" v-else>
        <p>汇总数据</p>
        <div class="statistics-item">
          <span class="dot"></span>
          <span>件数：</span>
          <span class="num">{{ statisticsData.policyNum }}件</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>保费：</span>
          <span class="num">{{ statisticsData.sumFee }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>标准保费：</span>
          <span class="num">{{ statisticsData.sumFoldFyb }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>奖励：</span>
          <span class="num">{{ statisticsData.rewardPrice || statisticsData.sumCommissionPrice }}元</span>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >条，共<span>{{ total }}</span
            >条数据</span
          >
        </div>
      </div>

      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange" row-key="uniqueKey">

          <template slot-scope="{ row }" slot="overName_staffNo">
            <div class="name-status">
              <div class="user-box">
                <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }" v-if="row.owerName"></i>
                <span class="user-name">{{ row.owerStaffNo }}</span>
                <span v-if="row.owerStaffNo">/</span>
                <span class="user-name">{{ row.owerName }}</span>
              </div>
            </div>
          </template>

          <template slot-scope="{ row }" slot="policyStatus">
            <span>{{ row.policyStatus | showPolicyStatusText }}</span>
          </template>

          <template slot-scope="{ row }" slot="calFactor">
            <span v-if="infoForm.reportType == '4-2' && activityDetailData.rewardType == 3">-</span>
            <span v-else>{{ row.calFactor | calFactorText }}</span>
          </template>

          <template slot-scope="{ row }" slot="receiptStatus">
            <span>{{ row.receiptStatus | receiptStatusText }}</span>
          </template>

          <template slot-scope="{ row }" slot="verifyStatus">
            <span>{{ row.verifyStatus | verifyStatusText }}</span>
          </template>

          <template slot="payPer">
            <span>1</span>
          </template>

          <template slot="policyYear">
            <span>1</span>
          </template>

          <template slot-scope="{ row }" slot="recommendname_staffNo">
            <div class="name-status">
              <div class="user-box">
                <i class="dian" :class="{ red: row.recommendWorkingState == 0, orange: row.isSus == 1 }"></i>
                <span class="user-name">{{ row.recommendStaffNo }}</span>
                <span v-if="row.recommendStaffNo">/</span>
                <span class="user-name">{{ row.recommend }}</span>
              </div>
            </div>
          </template>
          
          <!-- 推荐人手机号 -->
          <template slot-scope="{ row }" slot="mobile3">
            <span class="text" v-if="row.eyeShow">{{ row.mobile }}</span>
            <span class="text" v-else>{{ row.recommendMobile }}</span>
            <span v-if="$units.pointAction('offline_81_4_0_0')">
              <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow" @click="openEye(row.recommendId, row)"></i>
              <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow" @click="openEye(row.recommendId, row)"></i>
            </span>
          </template>

          <div slot-scope="{ row, index }" slot="beRecommendNum">
            <Poptip :placement="index == 0 ? 'bottom' : 'left'" width="700">
              <span style="cursor: pointer" class="table-btn">{{ row.beRecommendedNum }}</span>
              <div class="api" slot="content">
                <Table :columns="gradientColumns2" :data="row.beRecommendedList">
                  <template slot-scope="{ row }" slot="berecommendname_staffNo">
                    <div class="name-status">
                      <div class="user-box">
                        <i
                          class="dian"
                          :class="{ red: row.beRecommendedWorkingState == 0, orange: row.beRecommendedIsSus == 1 }"
                          v-if="row.beRecommendedName"
                        ></i>
                        <span class="user-name">{{ row.beRecommendStaffNo }}</span>
                        <span v-if="row.beRecommendStaffNo">/</span>
                        <span class="user-name">{{ row.beRecommendedName }}</span>
                      </div>
                    </div>
                  </template>

                  <!-- 被推荐人手机号 -->
                  <template slot-scope="{ row }" slot="beMobile3">
                    <span class="text" v-if="row.eyeShow">{{ row.mobile }}</span>
                    <span class="text" v-else>{{ row.beRecommendedMobile }}</span>
                    <span v-if="$units.pointAction('offline_81_4_0_0')">
                      <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow" @click="openEye(row.beRecommendedId, row)"></i>
                      <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow" @click="openEye(row.beRecommendedId, row)"></i>
                    </span>
                  </template>
                </Table>
              </div>
            </Poptip>
          </div>

          <template slot-scope="{ row }" slot="action">
            <span class="table-btn-disabled" v-if="nextData.settled">删除</span>
            <span class="table-btn" @click="delRow([row.id])" v-else>删除</span>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 100px" />
      </div>
    </div>

    <div style="height: 110px"></div>
    <div class="footer-action">
      <div>
        <Button type="primary" class="btn" @click="save(false, 0, false)" :loading="saveLoading">保存</Button>
        <Button type="primary" ghost @click="back('/financialManage/activitySettlement')">返回</Button>
        <Button type="primary" ghost @click="save(true, 1, false)" v-if="!nextData.settled" :loading="nextStepLoading">下一步</Button>
        <Button type="primary" ghost @click="settledNextStep" v-else>下一步</Button>
        <Button type="primary" ghost @click="save(true, 2, false)" :disabled="nextData.settled">选择待结算数据</Button>
        <Button type="primary" ghost @click="batchDelete" :disabled="nextData.settled">批量删除</Button>
      </div>
    </div>

    <!-- 出单-梯度 -->
    <selectPolicyOrderGradient ref="selectPolicyOrderGradientRef" :reportId="reportId" @success="searchAjax"></selectPolicyOrderGradient>

    <!-- 出单-无门槛 -->
    <selectPolicyOrderThreshold ref="selectPolicyOrderThreshold" :reportId="reportId" @success="searchAjax"></selectPolicyOrderThreshold>

    <!-- 增员-无门槛 -->
    <selectPolicyThreshold ref="selectPolicyThresholdRef" :reportId="reportId" @success="searchAjax"></selectPolicyThreshold>

    <!-- 增员-梯度 -->
    <selectPolicyGradient ref="selectPolicyGradientRef" :reportId="reportId" @success="searchAjax"></selectPolicyGradient>
    
    <!-- 签约活动 -->
    <select-sign-user ref="selectSignUser" :reportId="reportId" @success="searchAjax" />

    <!-- 导入数据 -->
    <selectImportData ref="importData" :reportId="reportId" @success="searchAjax"></selectImportData>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import { config } from './step1.config.js';
import { filterTime } from '@/api/filter';
import selectTree from '@/components/system/selectTree3';
import selectPolicyThreshold from '../components/selectPolicyThreshold';
import selectPolicyGradient from '../components/selectPolicyGradient';
import selectPolicyOrderGradient from '../components/selectPolicyOrderGradient';
import selectPolicyOrderThreshold from '../components/selectPolicyOrderThreshold';
import selectSignUser from '../components/selectSignUser';
import selectImportData from '../components/selectImportData';

export default {
  mixins: [pageTool, common, config],
  components: {
    selectTree,
    selectPolicyThreshold,
    selectPolicyGradient,
    selectPolicyOrderGradient,
    selectPolicyOrderThreshold,
    selectSignUser,
    selectImportData
  },
  props: {
    nextData: {
      type: Object,
      default: {}
    }
  },
  filters: {
    showPolicyStatusText(val) {
      switch (val) {
        case '-1':
          return '已退保';
        case '0':
          return '已终止';
        case '1':
          return '已承保';
        case '2':
          return '已中止';
        default:
          return '-';
      }
    },
    // 计算因子
    calFactorText(val) {
      switch (val) {
        case 1:
          return '业务员标保';
        case 2:
          return '业务员规保';
        case 3:
          return '业务员费用';
        default:
          return '-';
      }
    },
    // 回执状态
    receiptStatusText(val) {
      switch (val) {
        case '-1':
          return '无需回执';
        case '0':
          return '待回执';
        case '1':
          return '回执成功';
        case '2':
          return '回执失败';
        default:
          return '-';
      }
    },
    // 回访状态
    verifyStatusText(val) {
      switch (val) {
        case '0':
          return '等待回访';
        case '1':
          return '回访成功';
        case '2':
          return '回访失败';
        case '3':
          return '无需回访';
        default:
          return '-';
      }
    }
  },
  data() {
    return {
      saveLoading: false,
      nextStepLoading: false,
      fold: true,
      foldData: true,
      isAdd: 0,
      search: {},
      infoForm: {
        settlementDate: '',
        reportType: '',
        activityType: '',
        type: '',
        orgIds: [],
        productType: null,
        activityId: '',
        activityIds: []
      },
      statisticsData: {
        sumFee: 0,
        sumFoldFyb: 0,
        sumCommissionPrice: 0
      },
      activityList: [],
      userList: [], //业务员
      total: 0,
      columns: [],
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      reportId: null,
      selectActObj: {
        productType: ''
      }, //当前选中的活动对象
      activityDetailData: {} //梯度活动详情
    };
  },
  async created() {
    // this.columns = this.recruitingColumns;
    this.isAdd = this.$route.query.isAdd;
    this.reportId = this.$route.query.reportId;
    let today = new Date();
    this.infoForm.settlementDate = filterTime(today, 'YYYY-MM-DD');
    this.getUserList();
    if ((this.isAdd == 0 && this.reportId) || (!this.nextData.settled && this.reportId)) {
      this.getDetailData();
      this.searchAjax();
      return;
    }
    // if(this.isAdd == '1'&& !this.reportId) {
    //   await this.getActivityList();
    // }
  },
  methods: {
    getData() {
      this.reportId = this.nextData.reportId;
      if (this.nextData.settled || this.isAdd == 1) {
        this.getDetailData();
        this.searchAjax();
      }
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
    },

    // 活动详情
    getActivityDetail(id) {
      this.$http({
        url: '/buz/merchantActivity/detail',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        this.activityDetailData = res.data;
      });
    },

    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: {
          orgaList: []
        }
      }).then(res => {
        this.userList = res.data;
      });
    },

    // 结算报表详情
    getDetailData(id = this.reportId) {
      this.$http({
        url: '/buz/userSettlementReport/read/detail',
        type: 'GET',
        data: {
          id
        }
      }).then(async res => {
        this.infoForm = res.data;
        if (res.data.type != 4 && res.data.activityType != 1) {
          await this.getActivityList();
        } else {
          await this.getActivityList(res.data.activityProductType);
        }
        if (res.data.type == 2 && res.data.activityType == 1) {
          this.columns = this.recruitingColumns;
          this.infoForm.reportType = '2-1'; //增员-无门槛
          this.$set(this.infoForm, 'activityId', res.data.activityIdList[0]);
        } else if (res.data.type == 2 && res.data.activityType == 2) {
          this.infoForm.reportType = '2-2';
          this.$set(this.infoForm, 'activityId', res.data.activityIdList[0]);
          this.columns = this.gradientColumns;
        } else if (res.data.type == '4' && res.data.activityType == '1') {
          this.infoForm.reportType = '4-1'; //出单-无门槛
          this.$set(this.infoForm, 'productType', res.data.activityProductType);
          this.$set(this.infoForm, 'activityIds', res.data.activityIdList);
        } else if (res.data.type == 4 && res.data.activityType == 2) {
          this.getActivityDetail(res.data.activityIdList[0]);
          this.infoForm.reportType = '4-2'; //出单-梯度
          this.$set(this.infoForm, 'activityId', res.data.activityIdList[0]);
        } else if (res.data.type == 5 && res.data.activityType == 2) {
          this.columns = this.signColumns;
          this.getActivityDetail(res.data.activityIdList[0]);
          this.infoForm.reportType = '5-2'; //出单-梯度
          this.$set(this.infoForm, 'activityId', res.data.activityIdList[0]);
        }
        this.$nextTick(() => {
          setTimeout(async () => {
            (await this.$refs.selectTreeRef) && this.$refs.selectTreeRef.openChange();
          }, 2000);
        });
      });
    },

    // 获取关联活动
    getActivityList(productType = null) {
      this.activityList = [];
      var data = {
        pageNo: 1,
        pageSize: 999,
        statusList: [1, -1],
        productType
      };
      if (this.infoForm.type == 4 && this.infoForm.activityType == 2) {
        // 出单-梯度
        data.type = 2;
        data.mode = 2;
        if (this.reportId) {
          data.filterHasReport = 1;
          data.reportId = this.reportId;
        } else {
          data.filterHasReport = 1;
        }
      } else if (this.infoForm.type == 4 && this.infoForm.activityType == 1) {
        // 出单-无门槛
        data.type = 2;
        data.mode = 1;
      } else if (this.infoForm.type == 2 && this.infoForm.activityType == 1) {
        // 增员-无门槛
        data.type = 1;
        data.mode = 1;
        delete data.productType;
      } else if (this.infoForm.type == 2 && this.infoForm.activityType == 2) {
        // 增员-梯度
        data.type = 1;
        data.mode = 2;
        data.statusList = [-1];
        delete data.productType;
        if (this.reportId) {
          data.filterHasReport = 1;
          data.reportId = this.reportId;
        } else {
          data.filterHasReport = 1;
        }
      } else if (this.infoForm.type == 5 && this.infoForm.activityType == 2) {
        // 签约活动
        data.type = 3;
        data.mode = 2;
      }
      // 出单-梯度活动（已结束的活动才可以结算）
      if (this.infoForm.type == 4 && this.infoForm.activityType == 2) {
        data.statusList = [-1];
      }
      return this.$http({
        url: '/buz/merchantActivity/getList',
        type: 'POST',
        data
      }).then(res => {
        this.activityList = res.data;
        if(this.infoForm.type == '4' && this.infoForm.activityType == '1'){
          this.$set(
            this.infoForm,
            'activityIds',
            this.activityList.map(item => item.id)
          );
          this.selectActObj.productType = productType;
        } else if(this.infoForm.activityIdList) {
          this.selectActObj = this.activityList.find(item => item.id == this.infoForm.activityIdList[0]);
        }
        if (
          (this.infoForm.type == 4 && this.infoForm.activityType == 2 && this.selectActObj.productType == 1) ||
          (this.infoForm.type == 4 && this.infoForm.activityType == 1 && (this.infoForm.productType == 1 || this.selectActObj.productType == 1))
        ) {
          // 个险
          this.columns = this.scaleColumns;
        } else if (
          (this.infoForm.type == 4 && this.infoForm.activityType == 2 && this.selectActObj.productType == 2) ||
          (this.infoForm.type == 4 && this.infoForm.activityType == 1 && (this.infoForm.productType == 2 || this.selectActObj.productType == 2))
        ) {
          // 团财
          this.columns = this.groupFinanceActColumns;
        }
        // 增员-梯度
        // if(this.infoForm.type == 2 && this.infoForm.activityType == 2) {
        //   this.selectActObj = await this.activityList.find(item => item.id == this.infoForm.activityIdList[0]);
        //   if(this.selectActObj.conditionalIndicator == 6) {
        //     // 保单标保
        //     this.columns = this.recruitingColumns;
        //   }else{
        //     // 增员人数
        //     this.columns = this.gradientColumns;
        //   }
        // }
      });
    },

    // 选择报表类型
    changeActivityType(value) {
      this.tableData = [];
      this.statisticsData.policyNum = 0.0;
      this.statisticsData.sumFee = 0.0;
      this.statisticsData.sumFoldFyb = 0.0;
      this.statisticsData.rewardPrice = 0.0;
      this.statisticsData.sumCommissionPrice = 0.0;
      if (value == '2-1') {
        //增员-无门槛
        this.$set(this.infoForm, 'type', '2');
        this.$set(this.infoForm, 'activityType', '1');
        this.$set(this.infoForm, 'activityId', '');
        delete this.infoForm.productType;
        this.columns = this.recruitingColumns;
        this.getActivityList();
      } else if (value == '2-2') {
        //增员-梯度
        this.$set(this.infoForm, 'type', '2');
        this.$set(this.infoForm, 'activityType', '2');
        this.$set(this.infoForm, 'activityId', '');
        delete this.infoForm.productType;
        this.columns = this.gradientColumns;
        this.getActivityList();
      } else if (value == '4-2') {
        this.$set(this.infoForm, 'type', '4');
        this.$set(this.infoForm, 'activityType', '2');
        delete this.infoForm.productType;
        this.$set(this.infoForm, 'activityId', '');
        this.getActivityList();
      } else if (value == '4-1') {
        this.$set(this.infoForm, 'type', '4');
        this.$set(this.infoForm, 'activityType', '1');
        // 默认回显个险
        this.$set(this.infoForm, 'productType', '1');
        this.$set(this.infoForm, 'activityId', []);
        this.columns = this.scaleColumns;
        this.getActivityList('1');
      } else if (value == '5-2') {
        this.$set(this.infoForm, 'type', '5');
        this.$set(this.infoForm, 'activityType', '2');
        // 默认回显个险
        this.$set(this.infoForm, 'productType', '1');
        this.$set(this.infoForm, 'activityId', []);
        this.columns = this.signColumns;
        this.getActivityList('1');
      } else {
        this.getStatisticsData();
      }
    },

    // 选择产品类型
    async changeProductType(value) {
      this.activityList = [];
      this.$set(this.infoForm, 'activityIds', []);
      await this.getActivityList(value);
      if (!this.nextData.settled) {
        this.save(false, 0, true);
      }
      if (value == 1) {
        // 个险
        this.columns = this.scaleColumns;
      } else if (value == 2) {
        // 团财
        this.columns = this.groupFinanceActColumns;
      }
    },

    // 选择活动
    changeActivitySelect(value) {
      if (this.reportId) {
        this.tableData = [];
        if (!this.nextData.settled) {
          this.save(false, 0, true);
        }
      }
      if (this.infoForm.reportType == '4-2') {
        this.getActivityDetail(value);
        let activityItem = this.activityList.find(item => item.id == this.infoForm.activityId);
        if (activityItem.productType == 1) {
          // 个险
          this.columns = [];
          this.columns = this.scaleColumns;
        } else {
          // 团财
          this.columns = [];
          this.columns = this.groupFinanceActColumns;
        }
      } else if (this.infoForm.reportType == '2-2') {
        // let activityItem = this.activityList.find(item => item.id == this.infoForm.activityId);
        // if(activityItem.conditionalIndicator == 6) {
        //   // 保单标保
        //   this.columns = this.recruitingColumns;
        // }else{
        //   // 增员人数
        //   this.columns = this.gradientColumns; //增员-梯度
        // }
        this.columns = this.gradientColumns; //增员-梯度
      }
      this.selectArr = [];
    },

    // 获取列表
    getList() {
      if (!this.reportId) {
        return;
      }
      this.listLoading = true;
      this.$http({
        url: '/buz/userSettlementData/read/page',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          reportId: this.reportId,
          ...this.search
        }
      })
        .then(res => {
          res.data.forEach(item => {
            if (this.infoForm.activityType == 2 && this.infoForm.type == 2) {
              item.uniqueKey = item.recommendId;
            }else{
              item.uniqueKey = item.id;
            }
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.$nextTick(() => {
            setTimeout(() => {
              this.$set(this, 'tableData', res.data);
              this.listLoading = false;
            }, 500);
            this.total = res.total;
          });
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 获取统计
    getStatisticsData() {
      if (!this.reportId) {
        return;
      }
      this.$http({
        url: '/buz/userSettlementData/statistics',
        type: 'POST',
        data: {
          reportId: this.reportId,
          ...this.search
        }
      }).then(res => {
        this.statisticsData = res.data;
      });
    },

    // 解密
    openEye(id, row) {
      if (!row.eyeShow) {
        this.descrypt(
          {
            query: id,
            operationFunction: 47,
            operationType: 2
          },
          row,
          'mobile',
          'offline_81_4_0_0'
        ).then(() => {
          this.$set(row, 'eyeShow', true);
        });
      } else {
        this.$set(row, 'eyeShow', false);
      }
    },

    // 删除
    delRow(ids) {
      if (!this.$units.pointAction('offline_81_4_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry(`确认删除操作？`).then(() => {
        this.$http({
          url: '/buz/userSettlementData/batchDel',
          type: 'POST',
          data: {
            ids,
            reportId: this.reportId,
            isAll: this.isAll ? 1 : 0,
            ...this.search
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.getList();
          this.selectArr = [];
          this.isAll = false;
        });
      });
    },

    // 批量删除
    batchDelete() {
      if (!this.$units.pointAction('offline_81_4_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (!this.total) {
        this.$notice.alert('暂无可删除数据');
        return;
      }
      if (!this.isAll && !this.selectArr.length) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.delRow(selectIds);
    },

    // 保存
    save(mark, btn, point = false) {
      this.$refs.infoFormRef.validate().then(async isok => {
        if (!isok) {
          return;
        }
        if (!this.$units.pointAction('offline_81_4_1') && !point) {
          this.$notice.error('无权操作，请联系您的上级');
          return;
        }
        if (!mark && !btn) {
          this.saveLoading = true;
        }
        if (mark && btn == 1) {
          this.nextStepLoading = true;
        }
        let activityList = (activityList = this.activityList.filter(item =>
          this.infoForm.reportType == '4-1' ? this.infoForm.activityIds.includes(item.id) : this.infoForm.activityId == item.id
        ));
        activityList = activityList.map(item => {
          return {
            name: item.name,
            id: item.id
          };
        });
        if (this.infoForm.reportType != '4-1') {
          this.selectActObj = await this.activityList.find(item => item.id == this.infoForm.activityId);
        }
        const params = {
          id: this.reportId,
          activityList, //活动
          reportName: this.infoForm.reportName, //结算报表名称
          orgIds: this.infoForm.orgIds, //结算机构id
          settlementDate: filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD'), //结算日期
          remark: this.infoForm.remark, //备注
          step: this.nextData.settled || btn == 1 ? 2 : 1,
          activityProductType: this.infoForm.reportType == '4-1' ? this.infoForm.productType : this.selectActObj.productType
        }
        if (this.infoForm.reportType) {
          const arr = this.infoForm.reportType.split('-');
          params.type = arr[0];
          params.activityType = arr[1];
        }
        this.$http({
          url: '/buz/userSettlementReport/saveReport',
          type: 'POST',
          data: params
        }).then(async res => {
          this.reportId = res.data.id;
          let activityNameData = activityList.map(item => item.name);
          if (!this.reportId) {
            this.$notice.success('操作成功');
          }
          if (mark && btn == 2) {
            if (this.infoForm.reportType == '4-2') {
              // 选择出单-梯度待结算
              this.$refs.selectPolicyOrderGradientRef.open(
                this.infoForm.activityId,
                this.infoForm.orgIds,
                activityNameData.join('，'),
                this.selectActObj,
                this.infoForm.activityType,
                this.infoForm.type,
                this.activityDetailData
              );
            } else if (this.infoForm.reportType == '4-1') {
              // 选择出单-无门槛待结算
              this.$refs.selectPolicyOrderThreshold.open(
                this.infoForm.activityIds,
                this.infoForm.orgIds,
                activityNameData.join('，'),
                this.infoForm.reportType,
                this.infoForm.productType
              );
            } else if (this.infoForm.reportType == '2-1') {
              // 选择增员-无门槛
              this.$refs.selectPolicyThresholdRef.open(this.infoForm.activityId, this.infoForm.orgIds, activityNameData.join('，'), this.infoForm.reportType);
            } else if (this.infoForm.reportType == '2-2') {
              // 选择增员-梯度-增员人数
              this.$refs.selectPolicyGradientRef.open(this.infoForm.activityId, this.infoForm.orgIds, activityNameData.join('，'), this.infoForm.reportType);
            } else if (this.infoForm.reportType == '5-2') {
              // 选择签约活动待结算
              this.$refs.selectSignUser.open(this.infoForm.activityId, this.infoForm.orgIds, activityNameData.join('，'), this.infoForm.reportType);
            }
          } else if (mark && btn == 3) {
            this.$refs.importData.open(this.infoForm.activityId, this.infoForm.orgIds, activityNameData.join('，'));
          } else if (mark && btn == 1) {
            this.nextStep();
          }
          this.searchAjax();
          this.saveLoading = false;
        });
      });
    },

    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },

    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.uniqueKey); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.uniqueKey); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.uniqueKey) && !selectIds.includes(item.uniqueKey)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.uniqueKey);
        } else if (!ids.includes(item.uniqueKey) && selectIds.includes(item.uniqueKey)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.uniqueKey), 1);
          selectIds.splice(selectIds.indexOf(item.uniqueKey), 1);
        }
      });
    },

    // 下一步
    nextStep() {
      if (!this.$units.pointAction('offline_81_4_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$http({
        url: '/buz/userSettlementDetail/buildSettlementDetail',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      })
        .then(res => {
          this.$emit('next', {
            reportId: this.reportId,
            reportName: this.infoForm.reportName,
            settlementDate: filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD'),
            reportType: this.infoForm.reportType,
            productType: this.infoForm.reportType == '4-1' ? this.infoForm.productType : this.selectActObj.productType,
            type: this.infoForm.type,
            activityType: this.infoForm.activityType
          });
          this.nextStepLoading = false;
        })
        .catch(() => {
          this.nextStepLoading = false;
        });
    },

    // 已结算下一步
    settledNextStep() {
      this.$emit('next', {
        reportId: this.reportId,
        reportName: this.infoForm.reportName,
        settlementDate: filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD'),
        reportType: this.infoForm.reportType,
        productType: this.infoForm.reportType == '4-1' ? this.infoForm.productType : this.selectActObj.productType,
        type: this.infoForm.type,
        activityType: this.infoForm.activityType
      });
    },

    changeTreeOrg(data) {
      if (data.length) {
        this.$set(this.infoForm, 'orgIds', data);
        if (!this.nextData.settled) {
          this.save(false, 0, true);
        }
      }
    },

    // 展开收起
    foldBtn(val) {
      if (val == 1) {
        this.fold = !this.fold;
      } else {
        this.foldData = !this.foldData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  color: #515c6f;
  font-size: 14px;
  margin-left: 20px;
}
.settlement-status {
  position: absolute;
  right: 20px;
  margin-top: 1px;
  margin-left: 20px;
  display: flex;
  .tag-settled {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 2px;
    font-size: 13px;
    color: #e3461f;
    border: 1px solid #ffc1b2;
    background: #fff5f2;
  }
  .tag-be {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    color: #35bf3f;
    border: 1px solid #abeaae;
    background: #f6fcf4;
  }
}
.foldblock {
  margin-bottom: 15px;
  display: inline-block;
  cursor: pointer;
  .title {
    font-size: 16px;
    font-weight: 800;
    margin: 0 10px;
    color: #3c464f;
  }
  .iconColor {
    color: #727c8e;
    margin-right: 2px;
  }
}

.form-container {
  padding: 0 30px;
}

.statistics-container {
  display: flex;
  align-items: center;
  margin: 10px 0;
  .statistics-item {
    display: flex;
    margin-left: 30px;
    .dot {
      width: 4px;
      height: 4px;
      background: #236dff;
      align-self: center;
      margin-right: 7px;
    }
    .num {
      color: #3c464f;
    }
  }
}

.tableBox {
  margin-top: 10px;
  .table-btn-disabled {
    cursor: no-drop;
    color: #c5c8ce;
  }
}
.footer-action {
  position: fixed;
  bottom: 0px;
  background: #fff;
  z-index: 999 !important;
  width: 98%;
  height: 120px;
  line-height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      vertical-align: middle;
    }
    i {
      color: #bababa;
      font-size: 13px;
      vertical-align: middle;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
